import { IBaseState } from "../index";
import { HistoryServices } from '../../services'
import { BaseHistoryParameter } from "../../models/base-history-paramter";
import {
  IHistoryResponse,
  IPropertyHistoryResponseModel,
  IPropertyHistoryParameterModel,
  IDemandHistoryResponseModel,
  IDemandHistoryParameterModel,
  IPersonHistoryResponseModel,
  IPersonHistoryParameterModel,
  IAgendaHistoryResponseModel,
  IAgendaHistoryParameterModel,
  HistoryResponse,
} from "../../models/history";
export interface IHistoryState extends IBaseState<HistoryServices, BaseHistoryParameter> {
  currentChild?: any | null;
  source?: {
    listOfPropertyGeneralHistory: IHistoryResponse<IPropertyHistoryResponseModel, IPropertyHistoryParameterModel> | null
    listOfPropertyMatchingHistory: IHistoryResponse<IPropertyHistoryResponseModel, IPropertyHistoryParameterModel> | null
    listOfPropertyRelationHistory: IHistoryResponse<IPropertyHistoryResponseModel, IPropertyHistoryParameterModel> | null
    listOfPropertyPropertyProspectHistory: IHistoryResponse<IPropertyHistoryResponseModel, IPropertyHistoryParameterModel> | null
    listOfDemandHistory: IHistoryResponse<IDemandHistoryResponseModel, IDemandHistoryParameterModel> | null
    listOfPersonHistory: IHistoryResponse<IPersonHistoryResponseModel, IPersonHistoryParameterModel> | null
    listOfAgendaHistory: IHistoryResponse<IAgendaHistoryResponseModel, IAgendaHistoryParameterModel> | null
  }
}
export class HistoryState implements IHistoryState {
  service: HistoryServices;
  currentChild?: any | null;
  source: {
    listOfPropertyGeneralHistory: IHistoryResponse<IPropertyHistoryResponseModel, IPropertyHistoryParameterModel>
    listOfPropertyMatchingHistory: IHistoryResponse<IPropertyHistoryResponseModel, IPropertyHistoryParameterModel>
    listOfPropertyRelationHistory: IHistoryResponse<IPropertyHistoryResponseModel, IPropertyHistoryParameterModel>
    listOfPropertyPropertyProspectHistory: IHistoryResponse<IPropertyHistoryResponseModel, IPropertyHistoryParameterModel>
    listOfDemandHistory: IHistoryResponse<IDemandHistoryResponseModel, IDemandHistoryParameterModel>
    listOfPersonHistory: IHistoryResponse<IPersonHistoryResponseModel, IPersonHistoryParameterModel>
    listOfAgendaHistory: IHistoryResponse<IAgendaHistoryResponseModel, IAgendaHistoryParameterModel>
  }
  /**
   *
   */
  constructor(options: IHistoryState) {
    this.service = new HistoryServices
    this.currentChild = {}
    this.source = {
      listOfPropertyGeneralHistory: new HistoryResponse<IPropertyHistoryResponseModel,
        IPropertyHistoryParameterModel>({
          listOfItems: [],
          loading: false,
          pagination: null
        }),
      listOfPropertyMatchingHistory: new HistoryResponse<IPropertyHistoryResponseModel,
        IPropertyHistoryParameterModel>({
          listOfItems: [],
          loading: false,
          pagination: null
        }),
      listOfPropertyRelationHistory: new HistoryResponse<IPropertyHistoryResponseModel,
        IPropertyHistoryParameterModel>({
          listOfItems: [],
          loading: false,
          pagination: null
        }),
      listOfPropertyPropertyProspectHistory: new HistoryResponse<IPropertyHistoryResponseModel,
        IPropertyHistoryParameterModel>({
          listOfItems: [],
          loading: false,
          pagination: null
        }),
      listOfDemandHistory: new HistoryResponse<IDemandHistoryResponseModel,
        IDemandHistoryParameterModel>({
          listOfItems: [],
          loading: false,
          pagination: null
        }),
      listOfPersonHistory: new HistoryResponse<IPersonHistoryResponseModel,
        IPersonHistoryParameterModel>({
          listOfItems: [],
          loading: false,
          pagination: null
        }),
      listOfAgendaHistory: new HistoryResponse<IAgendaHistoryResponseModel,
        IAgendaHistoryParameterModel>({
          listOfItems: [],
          loading: false,
          pagination: null
        }),
    }
  }
} 